const image = {
    methods: {
        image(upload, size = 'xs') {
            if(upload) {
                if (typeof upload === 'string') {
                    if (upload.startsWith('http') || upload.startsWith('/storage') || upload.startsWith('/img')) {
                        return upload;
                    }
                }

                if (upload.urls && upload.urls[size]) {
                    return upload.urls[size];
                }

                const { host, original_file } = upload;
                const path = `${host}/${size}/${original_file}`;
                
                if (window.Laravel && window.Laravel.is_s3 && window.Laravel.s3_url) {
                    const s3Url = window.Laravel.s3_url.endsWith('/') ? window.Laravel.s3_url.slice(0, -1) : window.Laravel.s3_url;
                    return `${s3Url}/${path}`;
                }
                
                return `/storage/${path}`;
            }
            // fallback image
            return '/img/img_placeholder.jpg';
        }
    }
}

export default image
